export default "__VITE_ASSET__bdac0554__"